module.exports = __webpack_public_path__ + "assets/img/2.06130196.png";